import React from 'react';
import '../styles/title.css'; 

export default function TitleSection() {
  return (
    <section className="title">
      <img
        src="/dibujos/optimized/portafolio1.png"
        alt="Ilustración principal"
        className="title-image"
      />
      <a
      href='https://www.instagram.com/dolly.art_/'
      target='_blank'
      rel="noopener noreferrer"
      >
      <img
      src="/dibujos/instagram.png"
      alt="logo-instagram"
      className='logo-ig'
      />
      </a>
    </section>
  );
}
